import React from 'react';

const PlusChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 11V4h-2v7H4v2h7v7h2v-7h7v-2z"
        />
    </svg>
);

PlusChunkySvg.displayName = 'PlusChunkySvg';
export default PlusChunkySvg;
